import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkText } from 'uitk-react-text';

import { useSearchWidgetContext } from 'features/search-widget';

function Branding(): JSX.Element {
  const { branding } = useSearchWidgetContext();

  return (
    <footer className="branding">
      <UitkLayoutFlex direction="column" justifyContent="center" alignItems="start" space="one" wrap="wrap">
        <UitkLayoutFlexItem>
          <div>
            <UitkText className="branding__label" inline="small" size={200} theme="emphasis">
              <LocalizedText message="product.search.branding.label.content.powered_by" />
            </UitkText>
          </div>
        </UitkLayoutFlexItem>

        <UitkLayoutFlexItem>
          <div>
            <UitkMark
              id="branding-logo"
              className="branding__logo"
              url={branding?.logo.url}
              size={UitkMarkSize.MEDIUM}
              description={branding?.logo.description}
            />
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </footer>
  );
}

export { Branding };
